module.exports = __webpack_public_path__ + "img/logo.3a13ecb9.png";